<template>
  <div class="social-dashboard h-100 w-100">
    <div class="container-fluid py-3">
      <ul class="nav nav-pills mb-3 justify-content-center" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" :class="{ active: activeTab === 'connect' }" @click="activeTab = 'connect'">
            <i class="fas fa-plug me-2"></i>Connessione
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" :class="{ active: activeTab === 'posts', disabled: !isFacebookConnected }" @click="activeTab = 'posts'">
            <i class="fas fa-edit me-2"></i>Post
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" :class="{ active: activeTab === 'campaigns', disabled: !isFacebookConnected }" @click="activeTab = 'campaigns'">
            <i class="fas fa-bullhorn me-2"></i>Campagne
          </button>
        </li>
      </ul>

      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" v-if="activeTab === 'connect'">
          <SocialConnect @connection-status="updateConnectionStatus" />
        </div>
        <div class="tab-pane fade show active" v-if="activeTab === 'posts'">
          <SocialPosts v-if="isFacebookConnected" />
          <div v-else class="text-center mt-5">
            <div class="alert alert-warning d-inline-block">
              Per gestire i post, devi prima connettere il tuo account Facebook nella scheda "Connessione".
            </div>
          </div>
        </div>
        <div class="tab-pane fade show active" v-if="activeTab === 'campaigns'">
          <SocialCampaigns v-if="isFacebookConnected" />
           <div v-else class="text-center mt-5">
            <div class="alert alert-warning d-inline-block">
              Per gestire le campagne, devi prima connettere il tuo account Facebook nella scheda "Connessione".
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocialConnect from './SocialConnect.vue'
import SocialPosts from './SocialPosts.vue'
import SocialCampaigns from './SocialCampaigns.vue'

export default {
  name: 'SocialDashboard',
  components: {
    SocialConnect,
    SocialPosts,
    SocialCampaigns
  },
  data() {
    return {
      activeTab: 'connect',
      isFacebookConnected: false
    }
  },
  methods: {
    updateConnectionStatus(status) {
      this.isFacebookConnected = status;
      if (status && this.activeTab === 'connect') {
          // Optional: Auto-switch to posts after connection
          // this.activeTab = 'posts';
      }
    }
  }
}
</script>

<style scoped>
.social-dashboard {
    background-color: #f0f2f5;
    min-height: 90vh;
}
</style>
